export function scrollToSection(id: string) {
  document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' })
}

export function openExternal(url: string) {
  window.open(url, '_blank', 'noopener,noreferrer')
}
